import { MouseEvent, useCallback } from "react";

import { useDynamicSectionContext } from "../contexts/dynamicSectionContext";
import { MappedSection } from "../models/mappedComponent";
import DynamicComponentListSection from "./listSection";
import { Props } from "./types";

export default function DynamicComponentList(props: Props) {
	const { scrollToSection, ...rest } = props;
	const { visibleSections } = useDynamicSectionContext();
	function sectionClicked(event: MouseEvent) {
		const section = event.currentTarget.getAttribute("data-section");
		scrollToSection(section);
	}

	const subSectionClicked = useCallback(
		(sectionName: string) => async (event: MouseEvent) => {
			const subsection = event.currentTarget.getAttribute("data-subsectionfor");
			await scrollToSection(sectionName, subsection);
		},
		[visibleSections, scrollToSection],
	);

	return <section id="componentList">{visibleSections.map(renderSection)}</section>;

	function renderSection(section: MappedSection, index: number) {
		return (
			<DynamicComponentListSection
				{...rest}
				section={section}
				index={index}
				key={index}
				sectionClicked={sectionClicked}
				subSectionClicked={subSectionClicked}
			/>
		);
	}
}
